export default __webpack_public_path__ + "static/media/logo.205b3644.svg";